import { t } from '@lingui/core/macro';
import { Button, Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useField } from 'formik';
import { AclAction } from 'shared/domains/apollo/generated/types';
import { getAccessLevelName } from './getAccessLevelName';
export function AccessLevelSelection(props) {
    const { name, disabled, onRemove } = props;
    const [field, meta, helpers] = useField(name);
    const hasError = Boolean(meta.touched && meta.error);
    const accessLevels = [
        {
            value: [AclAction.Read],
            label: t({ message: 'Viewer', comment: 'Access level name' }),
            icon: <Falcon icon="eye"/>,
            description: t({
                message: 'Can view the content',
                comment: 'Access level description',
            }),
        },
        {
            value: [AclAction.Read, AclAction.Write, AclAction.Delete],
            label: t({ message: 'Editor', comment: 'Access level name' }),
            icon: <Falcon icon="pen-to-square"/>,
            description: t({
                message: 'Can view, edit and delete the content',
                comment: 'Access level description',
            }),
        },
    ];
    const handleSelectAccessLevel = (actions) => {
        helpers.setValue(Object.assign(Object.assign({}, field.value), { actions }));
    };
    const isSelected = (value) => {
        const lengthMatch = value.length === field.value.actions.length;
        const valueMatch = value.every((action) => field.value.actions.includes(action));
        return lengthMatch && valueMatch;
    };
    return (<Menu.Root target={<Button type="button" disabled={disabled} appearance={hasError ? 'danger' : 'secondary'} size="xs">
          {getAccessLevelName(field.value.actions)}
          {!disabled && <Falcon icon="chevron-down"/>}
        </Button>}>
      {accessLevels.map((level) => (<Menu.ItemRadio key={level.label} checked={isSelected(level.value)} onChange={() => handleSelectAccessLevel(level.value)}>
          {level.icon}
          <Menu.ItemText primary={level.label} secondary={level.description}/>
        </Menu.ItemRadio>))}
      <Menu.Divider />
      <Menu.Item onClick={onRemove}>
        <Falcon icon="xmark"/>
        <Menu.ItemText primary={t({ message: 'No access', comment: 'Access management - Remove access menu item' })} secondary={t({
            message: 'Remove access completely',
            comment: 'Access management - Remove access menu item',
        })}/>
      </Menu.Item>
    </Menu.Root>);
}
